module.exports = __webpack_public_path__ + "448d63982ddc6dce09bdc997666d7c06.png";